import React from 'react';

type BellIconProps = React.SVGProps<SVGSVGElement>;

export const BellIcon: React.FC<BellIconProps> = (props) => (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <path
      d="M9.77516 16.6666C9.62865 16.9192 9.41836 17.1289 9.16535 17.2746C8.91234 17.4203 8.62548 17.497 8.3335 17.497C8.04151 17.497 7.75465 17.4203 7.50164 17.2746C7.24863 17.1289 7.03834 16.9192 6.89183 16.6666M13.3335 5.83331C13.3335 4.50723 12.8067 3.23546 11.869 2.29778C10.9313 1.3601 9.65958 0.833313 8.3335 0.833313C7.00741 0.833313 5.73564 1.3601 4.79796 2.29778C3.86028 3.23546 3.3335 4.50723 3.3335 5.83331C3.3335 11.6666 0.833496 13.3333 0.833496 13.3333H15.8335C15.8335 13.3333 13.3335 11.6666 13.3335 5.83331Z"
      stroke="#717680"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BellIcon.displayName = 'BellIcon';

export default BellIcon;
